import React, { useState } from "react";
import Styles from "../../../Styles/TraderDashboard/TraderModal.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { el } from "date-fns/locale";

const TraderModal = ({
  open,
  handleClose,
  traderList,
  trader,
  handleSubmit,
  allResPonse,
}) => {
  const [tradersel, setTraderSel] = useState(trader);

  const handleModalSubmit = () => {
    allResPonse["traderAssigned"] = tradersel;
    handleSubmit(allResPonse);
  };

  const handleSelTrader = (value) => {
    setTraderSel(value);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={Styles.modalTraderContainer}>
        <div className={Styles.headerContainer}>
          <div className={Styles.headerText}>Trader Selection</div>
          <div onClick={handleClose}>
            <Close />
          </div>
        </div>
        <div>
          <div className={Styles.selectTraderCont}>
            <span className={Styles.traderHeadingText}>
              Select / Update Trader
            </span>
            <div>
              <div
                className={Styles.radioContainer}
                onClick={() => handleSelTrader(0)}
              >
                <input
                  checked={tradersel === 0}
                  type="radio"
                  name=""
                  id=""
                  value={tradersel}
                />
                <label htmlFor="">None</label>
              </div>

              {traderList
                ?.filter((ele) => ele?.id !== 139)
                ?.map((ele) => (
                  <div
                    className={Styles.radioContainer}
                    onClick={() => handleSelTrader(ele?.id)}
                  >
                    <input
                      checked={tradersel === ele?.id}
                      type="radio"
                      name=""
                      id=""
                      value={tradersel}
                    />
                    <label htmlFor="">
                      {ele?.userName === "gridco_trader"
                        ? "Gridco"
                        : ele?.userName}
                    </label>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className={Styles.submitSection} onClick={handleModalSubmit}>
          Submit
        </div>
      </div>
    </Modal>
  );
};

export default TraderModal;
